import { useEffect, useState } from "react";
import { memberApi } from "../lib/api";
import { toast } from "sonner";

const money = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} $`;

// Portail parent : enfants au dossier, abonnement commun, carte commune modifiable, reçus famille PDF.
export default function MemberFamilySection() {
  const [fam, setFam] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { memberApi.get("/member/family").then((r) => setFam(r.data)).catch(() => setFam(null)); }, []);

  const changeCard = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await memberApi.post("/member/payment/change-card-session", { origin: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Impossible d'ouvrir Stripe"); setBusy(false); }
  };
  const openReceipt = async (id) => {
    try { const r = await memberApi.get(`/member/family/receipts/${id}.pdf`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); }
    catch { toast.error("Reçu indisponible"); }
  };

  if (!fam || !fam.is_payer || fam.members.length < 2) return null;

  return (
    <section className="border border-white/10 bg-white/[0.02] p-6 mb-8 kz-fade-up" data-testid="member-family-section">
      <p className="kz-mono text-[10px] tracking-[0.26em] uppercase text-white/40">Ma famille · paiement commun</p>
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mt-1">
        <div>
          <h2 className="kz-display text-2xl">{fam.members.length} membres · {money(fam.monthly_total)} / période</h2>
          {fam.single_invoice
            ? <p className="text-emerald-400 text-sm mt-1" data-testid="family-single-invoice">✓ Une seule facture pour toute la famille — un seul reçu par période.</p>
            : <p className="text-white/50 text-sm mt-1" data-testid="family-multi-invoice">{fam.distinct_subscriptions} abonnements distincts. Demande au dojo de les regrouper en une seule facture.</p>}
        </div>
        <div className="text-right">
          {fam.card.has_card ? (
            <>
              <div className="text-white font-medium" data-testid="family-card">{String(fam.card.brand || "Carte").toUpperCase()} •••• {fam.card.last4} <span className="text-white/40 text-xs">exp {String(fam.card.exp_month).padStart(2, "0")}/{fam.card.exp_year}</span></div>
              <button onClick={changeCard} disabled={busy} className="mt-2 px-4 py-2 text-sm bg-white/10 hover:bg-white hover:text-[#0A0A0A] transition-colors" data-testid="family-change-card-btn">
                {busy ? "Ouverture…" : "Changer la carte de la famille"}
              </button>
            </>
          ) : (
            <button onClick={changeCard} disabled={busy} className="px-4 py-2 text-sm bg-[#D90429] hover:bg-white hover:text-[#0A0A0A] transition-colors" data-testid="family-add-card-btn">
              {busy ? "Ouverture…" : "Enregistrer la carte de la famille"}
            </button>
          )}
          <p className="text-white/40 text-[11px] mt-1 max-w-[260px]">La nouvelle carte s'applique automatiquement à tous les abonnements de la famille. Sécurisé par Stripe.</p>
        </div>
      </div>
      <ul className="mt-4 divide-y divide-white/10" data-testid="family-members-list">
        {fam.members.map((m) => (
          <li key={m.id} className="py-2 flex items-center justify-between gap-3 text-sm" data-testid={`family-member-${m.id}`}>
            <span className="text-white">{m.full_name}{m.is_self && <span className="text-white/40 text-xs ml-1">(moi)</span>} <span className="text-white/40">· {(m.discipline || "").replace(/_/g, " ")}</span></span>
            <span className="text-white/60 text-xs">{money(m.tarif_mensuel)}{m.next_payment ? ` · prochain ${m.next_payment}` : ""}{m.shared_subscription && <span className="ml-2 text-emerald-300">1 facture ✓</span>}</span>
          </li>
        ))}
      </ul>
      {fam.receipts.length > 0 && (
        <div className="mt-4 pt-3 border-t border-white/10" data-testid="family-receipts-list">
          <p className="text-white/60 text-xs uppercase tracking-wider mb-2">Reçus famille</p>
          <ul className="space-y-1 text-sm">
            {fam.receipts.map((r) => (
              <li key={r.id} className="flex items-center justify-between gap-2" data-testid={`family-receipt-${r.id}`}>
                <span className="text-white/80">{r.number} · {r.period_start} → {r.period_end} · {(r.member_names || []).join(", ")}</span>
                <span className="text-white/70">{money(r.total)} <button onClick={() => openReceipt(r.id)} className="ml-2 text-[#C9A961] underline" data-testid={`family-receipt-pdf-${r.id}`}>PDF</button></span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
